import * as Joi from "joi";
import { Column, Entity, JoinColumn, OneToOne } from 'typeorm';
import { GenPartial } from 'typeormgen';
import EpisodicActorNoteBase from '../episodic-actor-note-base.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';

@Entity('ha_episodic_actors')
export default class HaEpisodicActor extends EpisodicActorNoteBase {
	static tableName = 'ha_episodic_actors';

	@Column('varchar')
	h_stylist: string;

	@Column('varchar')
	wig_size: string;

	@Column('varchar')
	h_note: string;

	@OneToOne(
		(type) => EpisodicActor,
		(episodicActor) => episodicActor.haEpisodicActor
	)
	@JoinColumn({
		name: 'episodic_actor_id',
	})
	episodicActor: EpisodicActor;

	static rules() {
		return {
			...EpisodicActorNoteBase.rules(),
			h_stylist: Joi.string().max(500).allow(''),
			wig_size: Joi.string().max(1000).allow(''),
			h_note: Joi.string().allow(null, ''),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			h_stylist: this.h_stylist,
			wig_size: this.wig_size,
			h_note: this.h_note,
		};
	}

	assign(props?: GenPartial<HaEpisodicActor>) {
		super.assign(props);

		if (typeof props.h_stylist !== 'string') {
			this.h_stylist = '';
		}

		if (typeof props.wig_size !== 'string') {
			this.wig_size = '';
		}
	}

	set note(note: string) {
		this.h_note = note;
	}

	get note() {
		return this.h_note;
	}
}
